export default {
  mergeStylesheets(content) {
    const sheets = content.querySelectorAll('style[data-gp-styled-element]');
    const refFrame = document.createElement('frame');
    refFrame.width = 0;
    refFrame.height = 0;
    document.body.appendChild(refFrame);

    const properties = {};
    sheets.forEach(sheet => refFrame.contentDocument.body.appendChild(sheet));
    [...refFrame.contentDocument.styleSheets].forEach(styleData => {
      [...styleData.rules].forEach(rules => {
        const breakpoint = rules.conditionText || 'all';
        if (!properties[breakpoint]) properties[breakpoint] = {};
        this.getRuleProperties(
          properties[breakpoint],
          (rules.cssRules && [...rules.cssRules]) || [rules]
        );
      });
    });
    refFrame.remove();
    const stylesheetContent = this.getCommon(properties);
    const merged = document.createElement('style');
    merged.innerHTML = stylesheetContent;
    content.prepend(merged);
  },
  getRuleProperties(properties, rules) {
    rules.forEach(rule => {
      const cssText = rule.cssText.split(';');
      for (let i = rule.style.length; i--; ) {
        if (!properties[rule.style[i]]) {
          properties[rule.style[i]] = {};
        }
        let value = rule.style[rule.style[i]];
        if (
          cssText.find(
            string =>
              string.includes(value.split('-')[0]) &&
              string.includes('!important')
          )
        ) {
          value += ' !important';
        }
        if (!properties[rule.style[i]][value]) {
          properties[rule.style[i]][value] = [];
        }
        properties[rule.style[i]][value].push(rule.selectorText);
      }
    });
  },
  getCommon(properties) {
    const selectors = {};
    for (const breakpoint in properties) {
      for (const property in properties[breakpoint]) {
        for (const value in properties[breakpoint][property]) {
          const selector = JSON.stringify([
            ...new Set(properties[breakpoint][property][value])
          ]);
          if (!selectors[selector]) selectors[selector] = [];
          selectors[selector].push({ breakpoint, property, value });
        }
      }
    }
    const styleMap = {};
    for (const selector in selectors) {
      selectors[selector].forEach(value => {
        if (!styleMap[value.breakpoint]) {
          styleMap[value.breakpoint] = {};
        }
        if (!styleMap[value.breakpoint][selector]) {
          styleMap[value.breakpoint][selector] = {};
        }
        styleMap[value.breakpoint][selector][value.property] = value.value;
      });
    }
    const breakpoints = Object.keys(styleMap).reverse();
    breakpoints.forEach(breakpoint => {
      if (!Object.keys(styleMap[breakpoint]).length) {
        delete styleMap[breakpoint];
      }
    });
    return this.getStylesheetContent(styleMap);
  },
  getStylesheetContent(styleMap) {
    let content = '';
    const breakpoints = Object.keys(styleMap).sort((a, b) => {
      const pxA = parseInt(a.replace(/\D/g, ''));
      const pxB = parseInt(b.replace(/\D/g, ''));
      return pxA - pxB;
    });
    breakpoints.forEach(breakpoint => {
      let selectorText = `@media ${breakpoint} {`;
      if (breakpoint === 'all') selectorText = '';
      content += `${selectorText}
      `;
      for (const selector in styleMap[breakpoint]) {
        content += this.getRuleText(selector, styleMap[breakpoint][selector]);
      }
      if (breakpoint !== 'all')
        content += `
      }
      `;
    });
    return content;
  },
  streamlineCascade(previous, current) {
    Object.keys(current).forEach(selector => {
      if (!previous[selector]) return;
      for (const property in current[selector]) {
        if (current[selector][property] === previous[selector][property]) {
          delete current[selector][property];
        }
      }
    });
    Object.keys(current).forEach(selector => {
      if (!Object.keys(current[selector]).length) {
        delete current[selector];
      }
    });
  },
  getRuleText(selectorText, properties) {
    let text = `
    `;
    const selectors = JSON.parse(selectorText);
    selectors.forEach(selector => (text += `${selector}, `));
    text = `${text.slice(0, -2)} {`;
    Object.keys(properties).forEach(property => {
      text += `
      ${property}: ${properties[property]};`;
    });
    text += `
  }`;
    return text;
  },
  getContentBreakpoints(classes) {
    return Object.keys(classes)
      .map(breakpoint => {
        const point = {
          text: breakpoint
        };
        const mediaSelectors = breakpoint.split('(');
        mediaSelectors.forEach(selector => {
          if (selector.includes('min-width')) {
            point.min = parseInt(selector.replace(/\D/g, ''), 10);
          }
          if (selector.includes('max-width')) {
            point.max = parseInt(selector.replace(/\D/g, ''), 10);
          }
        });
        return point;
      })
      .filter(
        breakpoint =>
          breakpoint.min || breakpoint.max || breakpoint.text === 'all'
      );
  }
};
